module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldSemiExt.dd461c4.woff";